import { render, staticRenderFns } from "./TablaRepositoriosComerciales.vue?vue&type=template&id=09f4d899"
import script from "./TablaRepositoriosComerciales.vue?vue&type=script&lang=js"
export * from "./TablaRepositoriosComerciales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports